var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRacha(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98.325,
    height: 52.094,
    viewBox: "0 0 98.325 52.094",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10367",
    "data-name": "Path 10367",
    d: "M1208.9,861.3c5.531,1.554,12.706,2.866,15.865,8.332,2.268,1.584,7.371,1.77,9.6,3.565,3.044,5.973-9.328,6.13-3.042,12.486,17.933.547,6.447,14.674-5.047,13.1-7.849,8.886-22.075-4.516-31.046,7.25-16.185,6.977-11.054-16.591-32.68-6.583,1.534-6.718-8.031-14.579-4.13-20.457-2.872-3.868-9.881-6.229-13.044-9.808,3.436-7.936,5.708-.3,8.562-7.912,5.34.445,13.734,5.665,18.585,1.267l6.676,3.058C1202.367,869.316,1179.185,851.281,1208.9,861.3Z",
    transform: "translate(-1143.879 -856.742)",
    fill: "#23262c",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRacha);
export default __webpack_public_path__ + "static/media/racha.8f51432d3fab55b862197a8950ad3307.svg";
export { ForwardRef as ReactComponent };